export function patchUrlProtocol(url: string, defaultProtocal = 'https'): string {
  const pattern = /^https?:/gi
  if (!pattern.test(url)) {
    return defaultProtocal + '://' + url
  }
  return url
}
